module.exports = ":host .seatingplan {\n  margin-bottom: 1em; }\n\n:host .headlines {\n  font-size: 0.85em;\n  font-weight: bold;\n  margin-bottom: 1em; }\n\n:host .content {\n  margin-bottom: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/ticket-quota-collection/visual-ticket-quota/visual-ticket-quota.presentation.scss
// module id = OH1M
// module chunks = 12